import OutsourcingPage from 'Views/outsourcing/OutsourcingPage'
import React from 'react'
import { graphql, PageProps } from 'gatsby'
import { OutsourcingPageQuery } from 'Typings/generated-gatsby-types'

export default function Outsourcing(props: PageProps<OutsourcingPageQuery>) {
  return <OutsourcingPage data={props.data?.strapiOutsourcingPage} path={props.path} />
}

export const query = graphql`
  query($language: String!) {
    strapiOutsourcingPage(locale: { eq: $language }) {
      seo {
        meta_title
        meta_description
        meta_image {
          localFile {
            publicURL
          }
        }
      }
      heading
      sub_heading
      projects {
        project {
          id
          name
          short_info
          description
          slug
          years
          work_type
          app_type
          show_overlay
          preview {
            localFile {
              publicURL
            }
          }
          views {
            localFile {
              publicURL
            }
          }
        }
      }
      sections {
        ...DynamicSections
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
